<template>
    <div class="o-page o-page--fullscreen bg-secondary">
        <router-view></router-view>
    </div>
</template>
